module.exports = __webpack_public_path__ + "img/personal-portfolio-landing.a686ed4b.webp";